import {
  IconDownload,
  IconEye,
} from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import { useState } from "react";
import ViewModal from "./ViewModal";
import { useFetchClientTickets } from "../../../apis/ticketManagementClientApis";
import moment from "moment";
import { useSelector } from "react-redux";
import { useLanguage } from "../../../context/LanguageContext";

export default function ReceivingTicketsTab() {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState<string | null>(null);

  const profile = useSelector((state: any) => state.auth?.profile);

  const openModal = (id: string) => {
    setSelectedTicketId(id);
    setIsOpen(true);
  };
  
  const closeModal = () => {
    setIsOpen(false);
    setSelectedTicketId(null);
  };

  const { data: ticketsData, isLoading } = useFetchClientTickets();
  const ticketsList = (ticketsData?.tickets || []).filter((t: any) => t.createdBy !== 'ADMIN');

  return (
    <>
      <div className=" ">
        <div className="flex items-center">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
            <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
              {t("Receiving Tickets")}
            </h1>
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch />
            </div>
          </div>
          <div className="relative ml-5">
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>

        <div className="bg-[#F7F6F2] rounded-tl-none rounded-3xl min-h-[300px]">
          {isLoading ? (
            <div className="flex justify-center items-center h-[300px]">{t("Loading tickets...")}</div>
          ) : (
            <ListView
              data={ticketsList}
              onRowClick={(ticket) => openModal(ticket.id)}
              columns={[
                { label: "#", render: (_, i) => i + 1 },
                {
                  label: t("Ticket ID"),
                  render: (c) => c.ticketNumber,
                },
                {
                  label: t("Sender"),
                  render: (c) => {
                    if (c.customerId) return t("Customer");
                    if (c.clientId) return t("Merchant");
                    return t("System");
                  },
                },
                {
                  label: t("Subject"),
                  render: (c) => c.subject,
                },
                {
                  label: t("AWB Number"),
                  render: (c) => c.awbNumber || "",
                },
                {
                  label: t("Type"),
                  render: (c) => t(c.type.replace("_", " ")),
                },
                {
                  label: t("Assigned To"),
                  render: (c) => c.assignedToName ? t(c.assignedToName) : t("Unassigned"),
                },
                {
                  label: t("Date & Time"),
                  render: (c) => moment(c.createdAt).format("DD-MMM-YY, h:mm A"),
                },
                {
                  label: t("Status"),
                  render: (c) => {
                    let statusClasses = "";
                    if (c.status === "IN_PROGRESS" || c.status === "ON_HOLD") {
                      statusClasses = "bg-[#FCB910]/10 text-[#FCB910] border border-[#FCB910]";
                    } else if (c.status === "RESOLVED" || c.status === "CLOSED") {
                      statusClasses = "bg-[#CDF3E5] text-[#43A581] border border-[#43A581]";
                    } else if (c.status === "OPEN" || c.status === "REOPENED") {
                      statusClasses = "bg-[#FF4848]/10 text-[#FF4848] border border-[#EC221F]";
                    }
                    return (
                      <button className={`rounded-full px-2 py-1 w-28 text-center text-xs font-medium inline-block ${statusClasses}`}>
                        {t(c.status.replace("_", " "))}
                      </button>
                    );
                  },
                },
                {
                  label: t("Actions"),
                  render: (c: any) => (
                    <div className="relative flex justify-center">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openModal(c.id);
                        }}
                        className="p-2 border rounded-full bg-[#F7F6F2]"
                      >
                        <IconEye size={22} />
                      </button>
                    </div>
                  ),
                },
              ]}
            />
          )}
        </div>
        
        {selectedTicketId && (
          <ViewModal open={isOpen} onClose={closeModal} ticketId={selectedTicketId} />
        )}
      </div>
    </>
  );
}
